<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('detailIntervention.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-2">
            <app-logo readOnly class="is-pulled-left"
                      :elementId="demandeIntervention.id"
                      :libelleElement="$t('detailIntervention.libelleForLogo',
                      { code: demandeIntervention.code })">
            </app-logo>
          </div>
          <div class="column is-10">
            <div class="columns is-multiline">
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.dateIntervention')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ demandeIntervention.datePlanification | formatDate }}
            </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.typeIntervention')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getLibelleTypeIntervention }}
            </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.demandeur')"
                  custom-class="has-text-weight-normal is-italic is-marginless">
                  <span class="has-text-weight-bold">
                    {{ getUserName }}
                  </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.source')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getLibelleSource }}
            </span>
                </b-field>
              </div>
              <div class="column is-3" v-if="isIntervention">
                <b-field :label="$t('detailIntervention.infoGenerale.typeOt')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getLibelleTypeOt }}
            </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.patrimoine')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold" v-if="getLibellePatrimoine">
                <router-link-blank :to="getRouterLinkPatrimoine"
                                   :message="getLibellePatrimoine"
                                   typeIcon="is-primary" sizeIcon="is-small">
                </router-link-blank>
            </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.agence')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
                {{ getLibelleAgence }}
            </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.etat')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
                  <span class="has-text-weight-bold">
                {{ getLibelleEtat }}
                  </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailIntervention.infoGenerale.dateLimite')"
                  custom-class="has-text-weight-normal is-italic is-marginless">
                  <span class="has-text-weight-bold">
                    {{ demandeIntervention.dateLimite | formatDate }}
                  </span>
                </b-field>
              </div>
              <div class="column is-3" v-if="isIntervention">
                <b-field :label="$t('detailIntervention.infoGenerale.OT')"
                         custom-class="has-text-weight-normal is-italic is-marginless">
                  <div class="has-text-weight-bold">
                    <router-link-blank :to="{ name: 'c.logistique.ordre_travail-tech',
        params: { id: demandeIntervention.otTechnique.id } }"
                                       v-if="demandeIntervention.otTechnique"
                                       :message="demandeIntervention.otTechnique.code"
                                       typeIcon="is-primary" sizeIcon="is-small">
                    </router-link-blank>
                  </div>
                </b-field>
              </div>
              <div class="column is-3" v-if="isIntervention">
                <b-field :label="$t('detailIntervention.infoGenerale.tags')"
                  custom-class="has-text-weight-normal is-italic is-marginless"
                >
                  <query-tags-tag-input class="mgt-2px"
                    v-model="demandeIntervention.tags"
                    field="tag"
                    is-detail>
                  </query-tags-tag-input>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  TYPE_INTERVENTION,
  SOURCE_INTERVENTION,
  INTERVENTION_TYPE_INTERVENTION,
  ETAT_DEMANDE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import Logo from '@/components/general/Logo';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');

export default {
  props: {
    demandeIntervention: {
      required: true,
      type: Object,
    },
  },
  components: {
    routerLinkBlank,
    appLogo: Logo,
    queryTagsTagInput,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    getLibelleEtat() {
      const etatFind = ETAT_DEMANDE_INTERVENTION.find((etat) => {
        return etat.key === this.demandeIntervention.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    getLibelleAgence() {
      const agenceFind = this.user.agences.find((agence) => {
        return agence.agenceId === this.demandeIntervention.agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    isIntervention() {
      return this.demandeIntervention.type === INTERVENTION_TYPE_INTERVENTION;
    },
    getLibelleTypeOt() {
      const typeOtFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === this.demandeIntervention.typeOtId;
      });
      return typeOtFind ? typeOtFind.libelle : null;
    },
    getLibelleTypeIntervention() {
      const typeIntFind = TYPE_INTERVENTION.find((type) => {
        return type.key === this.demandeIntervention.type;
      });
      return typeIntFind ? this.$i18n.t(typeIntFind.libelle) : null;
    },
    getLibelleSource() {
      const sourceFind = SOURCE_INTERVENTION.find((source) => {
        return source.key === this.demandeIntervention.source;
      });
      return sourceFind ? this.$i18n.t(sourceFind.libelle) : null;
    },
    getUserName() {
      if (!this.demandeIntervention.demandeurId) return '';
      return nomPrenomGetter(this.demandeIntervention.demandeur);
    },
    getLibellePatrimoine() {
      if (this.demandeIntervention.faceId) {
        return this.$i18n.t('detailIntervention.infoGenerale.patrimoineInfo.face', {
          ref: this.demandeIntervention.infoPatrimoine.face.code,
        });
      }
      if (this.demandeIntervention.materielId) {
        return this.$i18n.t('detailIntervention.infoGenerale.patrimoineInfo.materiel', {
          ref: this.demandeIntervention.infoPatrimoine.materiel.code,
        });
      }
      if (this.demandeIntervention.dispositifId) {
        return this.$i18n.t('detailIntervention.infoGenerale.patrimoineInfo.dispositif', {
          ref: this.demandeIntervention.infoPatrimoine.dispositif.code,
        });
      }
      if (this.demandeIntervention.emplacementId) {
        return this.$i18n.t('detailIntervention.infoGenerale.patrimoineInfo.emplacement', {
          ref: this.demandeIntervention.infoPatrimoine.emplacement.code,
        });
      }
      return null;
    },
    getRouterLinkPatrimoine() {
      if (this.demandeIntervention.faceId) {
        return {
          name: 'c.gabed.emplacement-face',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
            idFace: this.demandeIntervention.infoPatrimoine.face.id,
          },
        };
      }
      if (this.demandeIntervention.materielId) {
        return {
          name: 'c.gabed.emplacement-detailMateriel',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
            idMateriel: this.demandeIntervention.infoPatrimoine.materiel.id,
          },
        };
      }
      if (this.demandeIntervention.dispositifId) {
        return {
          name: 'c.gabed.emplacement-detailDispositif',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
            idDispositif: this.demandeIntervention.infoPatrimoine.dispositif.id,
          },
        };
      }
      if (this.demandeIntervention.emplacementId) {
        return {
          name: 'c.gabed.emplacement-detailEmplacement',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
          },
        };
      }
      return null;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
};

</script>
